__turbopack_context__.v({
  "chaptersOverlay": "Ok-5Yq_chaptersOverlay",
  "fill": "Ok-5Yq_fill",
  "hoverFill": "Ok-5Yq_hoverFill",
  "segment": "Ok-5Yq_segment",
});
